<template>
  <div ref="TrainingAndFaqs" class="grid-module training-ang-faqs">
    <AskQuestion
        :active="questionModalActive"
        :email-sending="emailSending"
        :email="email"
        @submit="submit"
        @close="closeModal"/>
    <b-modal v-if="videoActive"
             ref="self"
             :active="videoActive"
             :custom-class="'dialog mpc videoPlayer'"
             has-modal-card
             :destroy-on-hide="true"
             aria-role="dialog"
             scroll="keep"
             aria-modal>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{this.videoList.catName}}</p>
          <p id="video-name">{{this.videoList.list[this.currentVideoIndex].name}}
            ({{this.currentVideoIndex +1}} of {{this.videoList.list.length}})</p>
          <button class="modal-close is-large active" aria-label="close"
                  @click="cancel(videoList.list[currentVideoIndex].categoryId,
                 videoList.list[currentVideoIndex].catType, currentLimit)">
          </button>
        </header>
        <section class="modal-card-body">
          <div class="main-preview-player">
            <vue-plyr ref="plyr">
              <div v-if="this.videoList.list[this.currentVideoIndex].videoType === 'youtube'"
                   data-plyr-provider="youtube"
                   :data-plyr-embed-id="this.videoList.list[this.currentVideoIndex].videoSrc">
              </div>
              <video v-else :poster="this.videoList.list[this.currentVideoIndex].videoImg"
                     playsinline controls>
                <source :src="this.videoList.list[this.currentVideoIndex].videoSrc"
                        :type="this.videoList.list[this.currentVideoIndex].videoType" />
              </video>
            </vue-plyr>
            <div class="playlist-container" id="plist">
              <div class="pl_video" v-for="(video, index) in this.videoList.list"
                   :value="video.name"
                   :key="index">
                <div class="playlist_video" v-if="video.name" >
                  <div class="playlist_img">
                    <img v-if="video.videoImg !== null" :src=video.videoImg alt=''>
                    <img v-else src="../assets/no_image.png" alt=''>
                    <span class="time" v-if="video.videoDuration">{{video.videoDuration}}</span>
                    <span class="check" v-if="video.videoStatus === 'ended'"></span>
                    <span class="arrow" :class="{'active': currentVideoId === video.id}"
                          @click="playItem(index)"></span>
                    <span class="track" v-if="video.videoTrack"
                          :style="{ width: video.videoTrack}"></span>
                  </div>
                  <div class="video-name">
                    {{video.name }}
                    <span class="green" v-if="video.isNewVideo"> (new)</span>
                  </div>
                </div>
              </div>
            </div>
            <b-loading :is-full-page="false" :active="isPreloading"
                       :can-cancel="false"></b-loading>
          </div>
        </section>
      </div>
    </b-modal>
    <h1>Training and FAQs</h1>
    <section v-for="cat in category.onboarding_training" :key="cat.id">
      <div class="banner" v-if="cat.id === onboardingIndex">
        <div class="banner_bg">
          <img
              src="../assets/training.png"
              alt="Training & FAQs"
          >
        </div>
        <div class="banner_content" >
          <h2 v-if="(cat.name || cat.countNewVideos > 0)">
            <span v-if="cat.name">{{ cat.name }}</span>
            <span class='new' v-if="cat.countNewVideos > 0">
            +{{ cat.countNewVideos }} new video</span></h2>
          <p>{{ cat.description }}</p>
          <b-button class="is-success"
                    @click="showModalVideo(cat.id, 1000, cat.name,
                    '', 1000)">START</b-button>
        </div>
      </div>
    </section>
    <section v-for="(cat, index) in category.training" :key="cat.id">
      <div class="traning_cat" :id="`traningVideos${cat.id}`">
        <h2>
          <span>Training: {{ cat.name }}</span>
          <span class='new' v-if="cat.countNewVideos > 0">
          +{{ cat.countNewVideos }} new video</span></h2>
        <p v-if="cat.description">{{ cat.description }}</p>
        <div class="traning_cat_videos">
          <div class="traning_cat_video" v-for="(material, key) in materialsByCat[cat.id]"
               :key="key">
            <div class="video" v-if="material.video !== null"
                 @click="showModalVideo(cat.id, key, cat.name, 'Training:', cat.limit)">
              <img v-if="material.videoImg !== null" :src=material.videoImg alt=''>
              <img v-if="material.videoImg === null" src="../assets/no_image.png" alt=''>
              <span class="arrow"></span>
              <span class="time" v-if="material.videoDuration">{{material.videoDuration}}</span>
              <span class="check" v-if="material.videoStatus === 'ended'"></span>
              <span class="track" v-if="material.videoTrack"
                    :style="{ width: material.videoTrack}"></span>
            </div>
            <div class="video-name">
              {{material.name }}
              <span class="green" v-if="material.isNewVideo"> (new)</span>
            </div>
          </div>
        </div>
        <b-button class="is-success show-more" :class="{'show': cat.show}"
                  :id="`showMore${cat.id}`" v-if="cat.total > perPage"
                  @click="materialsByCategory(index, cat.id, cat.type, (perPage + cat.limit), false
                  )">SHOW MORE</b-button>
        <b-button class="is-success hide-more" :class="{'show': !cat.show}" id="hide-more"
                  v-if="cat.total > perPage"
                  @click="materialsByCategory(index, cat.id, cat.type, perPage,
                  true)">HIDE</b-button>
      </div>
    </section>
    <section >
      <div class="faqs_cat" v-if="category.faqs">
        <div>
          <h2>Frequently Asked Questions</h2>
          <p>Watching these will train you how best to go about adopting Enhancify into
            your business. Feel free to email support if you have any questions
            after watching.</p>
        </div>
        <b-collapse
            class="faqs_cat_faqs"
            animation="slide"
            v-for="(catFaqs, index) in category.faqs" :key="catFaqs.id"
            :open="isOpen == index"
            @open="isOpen = index"
            :aria-id="'contentIdForA11y5-' + index">
          <template #trigger="props">
            <div
              class=""
              role="button"
              :aria-controls="'contentIdForA11y5-' + index"
              :aria-expanded="props.open"
            >
              <h3 class="category-h3">
                <span class="icon category_lvl_1">
                  <Icon
                    width="20"
                    height="12"
                    viewBox="0 0 20 12"
                    color="white"
                    :icon="props.open ? 'angle-up' : 'angle-down'"
                  />
                </span>
                <span>
                {{ catFaqs.name }}
                </span>
              </h3>
              <p v-if="catFaqs.description">{{ catFaqs.description }}</p>
            </div>
          </template>
          <div class="">
            <b-collapse
                class="faq"
                animation="slide"
                v-for="(content, key) in materialsByCat[catFaqs.id]" :key="content.id"
                :open="isOpen1 == key"
                @open="isOpen1 = key"
                :aria-id="'contentIdForA11y51-' + key">
              <template #trigger="props">
                <div
                  class="content"
                  role="button"
                  :aria-controls="'contentIdForA11y51-' + key"
                  :aria-expanded="props.open"
                >
                  <div class="question">
                    <div class="icon category_lvl_2">
                      <Icon
                        width="20"
                        height="12"
                        viewBox="0 0 20 12"
                        color="#68ba62"
                        :icon="props.open ? 'angle-up' : 'angle-down'"
                      />
                    </div>
                    <div>
                      {{ content.name }}
                    </div>
                  </div>
                </div>
              </template>
              <div class="answer" v-html="content.content"></div>
            </b-collapse>
          </div>
        </b-collapse>
        <div class="asq-question">
          <div class="asq-question_bg">
            <img
                src="../assets/faqs.png"
                alt="Still have a question?"
            >
            <div>STILL HAVE A QUESTION?</div>
          </div>
          <div class="asq-question_content">
            <b-button class="is-success"  @click.prevent="openModal()"
                      :loading="codeLoading">ASK QUESTION HERE</b-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  materialsCategory,
  materialsByCategoryId,
  sendQuestion,
  setStatVideo,
} from '@/api/materials';

import Vue from 'vue';
import VuePlyr from 'vue-plyr';
import AskQuestion from '../components/Modal/AskQuestion.vue';
import Icon from '../components/Icon.vue';

Vue.use(VuePlyr, {
  plyr: {
    invertTime: false,
    autoplay: true,
    muted: true,
    resetOnEnd: false,
    ratio: '16/10',
    captions: { active: true },
    fullscreen: {
      enabled: true,
      iosNative: true,
    },
    youtube: {
      noCookie: false,
      rel: 0,
      showinfo: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 1,
      controls: 0,
      playsinline: false,
    },
  },
});

export const CATEGORY_TYPE_ONBOARDING = 'onboarding_training';
export const CATEGORY_TYPE_TRAINING = 'training';
export const CATEGORY_TYPE_FAQS = 'faqs';
export const CATEGORIES_CONTENT_TYPE_TEXT = [
  CATEGORY_TYPE_FAQS,
];
export const CATEGORIES_CONTENT_TYPE_VIDEO = [
  CATEGORY_TYPE_ONBOARDING,
  CATEGORY_TYPE_TRAINING,
];
export const TYPES_MATERIALS_CATEGORIES = [
  ...CATEGORIES_CONTENT_TYPE_TEXT,
  ...CATEGORIES_CONTENT_TYPE_VIDEO,
];

export const MATERIAL_VIDEO_TYPE_YOUTUBE = 'youtube';
export const MATERIAL_VIDEO_TYPE_MP4 = 'video/mp4';
export const MATERIAL_VIDEO_TYPES = [
  MATERIAL_VIDEO_TYPE_YOUTUBE,
  MATERIAL_VIDEO_TYPE_MP4,
];

export default {
  name: 'TrainingAndFaqs',
  props: {
  },
  components: {
    AskQuestion,
    Icon,
  },
  data() {
    return {
      /** Categories names constants */
      CATEGORY_TYPE_ONBOARDING,
      CATEGORY_TYPE_TRAINING,
      CATEGORY_TYPE_FAQS,
      category: {
        count_new_videos: 0,
        description: null,
        id: 0,
        limit: 4,
        name: null,
        order: 0,
        show: true,
        total: 0,
        has_materials: true,
      },
      materials: [],
      videoEnabled: 0,
      materialsByCat: {
        data: [],
        total: 0,
        page: 1,
        limit: 4,
      },
      videosByCat: {
        data: [],
        total: 0,
        page: 1,
        limit: 1000,
      },
      isOpen: 0,
      isOpen1: 0,
      not: false,
      opened: true,
      currentIndex: 1,
      currentQuestion: 0,
      codeLoading: false,
      emailSending: false,
      questionModalActive: false,
      perPage: 4,
      limit: 4,
      total: 0,
      page: 1,
      show: false,
      onboardingIndex: 0,
      videoActive: false,
      codeVideo: null,
      imgVideo: null,
      videoList: {},
      list: [],
      player: {},
      currentVideoId: 0,
      currentVideoIndex: 0,
      currentVideoCatCount: 0,
      currentLimit: 1000,
      stat: {},
      videoNotEnded: [],
      videoEnded: [],
      notPlay: false,
      isPreloading: false,
      isPlaying: false,
    };
  },
  computed: {
    ...mapState('user', { userId: (state) => state.id }),
    ...mapState('contractor', { contractorId: (state) => state.id, email: (state) => state.email }),
    ...mapGetters(['isSwitched', 'userAuthenticator', 'authAuthenticator']),
  },
  mounted() {
    this.getPageParams();
  },
  watch: {
    userId() {
      this.category = {};
      this.materialsByCat = {};
      this.getPageParams();
    },
  },
  methods: {
    getPageParams() {
      if (this.userId === null) return;
      materialsCategory(this.userId).then((response) => {
        this.$set(this, 'category', response.data.data);
        if (this.category.onboarding_training) {
          this.onboardingIndex = Object.values(this.category.onboarding_training)[0].id;
        }
        if (this.category.faqs) {
          this.currentIndex = Object.values(this.category.faqs)[0].id;
        }
        if (this.category.training) {
          Object.entries(this.category.training).forEach(([key, value]) => {
            materialsByCategoryId(
              this.userId, value.id,
              this.page, this.limit,
            ).then((newresponse) => {
              this.$set(this.materialsByCat, value.id, newresponse.data.data);
              this.$set(this.category.training[key], 'total', newresponse.data.total);
              this.$set(this.category.training[key], 'limit', this.limit);
              this.$set(this.category.training[key], 'show', true);
            })
              .catch((error) => {
                this.error = error;
              });
          });
        }
        if (this.category.faqs) {
          Object.values(this.category.faqs).forEach((value) => {
            materialsByCategoryId(
              this.userId, value.id,
              this.page, 1000,
            ).then((newresponse) => {
              this.$set(this.materialsByCat, value.id, newresponse.data.data);
            })
              .catch((error) => {
                this.error = error;
              });
          });
        }
      })
        .catch((error) => {
          this.error = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    materialsByCategory(catIndex, catId, catType, limit, focus) {
      this.catId = catId;
      this.limit = limit;
      this.catType = catType;
      if (this.userId === null) return;
      materialsByCategoryId(
        this.userId, this.catId,
        this.page, this.limit,
      ).then((response) => {
        this.$set(this.materialsByCat, this.catId, response.data.data);
        if (this.catType === this.CATEGORY_TYPE_TRAINING) {
          this.$set(this.category.training[catIndex], 'total', response.data.total);
          this.$set(this.category.training[catIndex], 'limit', this.limit);
          this.show = response.data.total > this.limit;
          this.$set(this.category.training[catIndex], 'show', this.show);
          this.$nextTick(() => {
            if (focus) {
              const element = document.getElementById(`showMore${catId}`);
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
        }
        if (this.catType === this.CATEGORY_TYPE_FAQS) {
          this.$set(this.category.faqs[this.catId], 'currentQuestion', response.data.data[0].id);
        }
      })
        .catch((error) => {
          this.error = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // toggleItem(index) {
    //   alert(1);
    //   this.currentIndex = this.currentIndex === index ? null : index;
    //   setTimeout(() => {
    //     const element = document.querySelector('.open');
    //     element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //   }, 300);
    // },
    closeModal() {
      this.questionModalActive = false;
    },
    openModal() {
      this.questionModalActive = true;
      this.$nextTick(() => {
        const elem = document.getElementById('question');
        elem.focus();
      });
    },
    showModalVideo(catId, index, catName, catType, limit) {
      this.catId = catId;
      this.limit = 1000;
      this.currentLimit = limit;
      this.catType = catType;
      if (this.userId === null) return;
      materialsByCategoryId(
        this.userId, this.catId,
        this.page, this.limit,
      ).then((response) => {
        this.$set(this.videoList, 'list', response.data.data);
        Object.entries(this.videoList.list).forEach((value, key) => {
          if (value[1].videoStatus !== 'ended') {
            this.videoNotEnded.push(key);
          } else {
            this.videoEnded.push(key);
          }
        });
        if (catName === null) {
          this.$set(this.videoList, 'catName', catType);
        } else {
          const name = `${catType} ${catName}`;
          this.$set(this.videoList, 'catName', name);
        }
        this.notPlay = false;
        if (index === 1000) {
          const [first] = this.videoNotEnded;
          this.currentVideoIndex = first;
          if (this.videoNotEnded.length === 0) {
            const [firstEnded] = this.videoEnded;
            this.currentVideoIndex = firstEnded;
          }
          this.notPlay = true;
        } else {
          this.currentVideoIndex = index;
        }
        this.currentVideoId = this.videoList.list[this.currentVideoIndex].id;
        this.currentVideoCatCount = this.videoList.list.length;
        this.openModalVideo();
        // this.isPreloading = true;
        this.$nextTick(() => {
          this.$refs.plyr.player.once('ready', () => {
            this.isPlaying = false;
            document.querySelector('.arrow.active').click();
          });
        });
      })
        .catch((error) => {
          this.error = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeNewVideo(catType) {
      this.catType = catType;
      if (this.userId === null) return;
      materialsCategory(this.userId).then((response) => {
        const cat = response.data.data;
        if (this.catType === this.CATEGORY_TYPE_ONBOARDING) {
          const onboardingId = Object.values(this.category.onboarding_training)[0].id;
          this.$set(this.category.onboarding_training[onboardingId], 'countNewVideos', Object.values(cat.onboarding_training)[0].countNewVideos);
        }
        if (this.catType === this.CATEGORY_TYPE_TRAINING) {
          Object.values(cat.training).forEach((value) => {
            this.$set(this.category.training[value.id], 'countNewVideos', value.countNewVideos);
          });
        }
      })
        .catch((error) => {
          this.error = error;
        })
        .finally(() => {
        });
    },
    closeModalVideo() {
      this.videoActive = false;
    },
    openModalVideo() {
      this.videoActive = true;
    },
    submit(question) {
      if (this.contractorId === null || this.userId === null) return;
      this.emailSending = true;
      const params = new FormData();
      params.set('contractorId', this.contractorId);
      params.set('userId', this.userId);
      params.set('question', (question));
      params.set('subject', 'Ask Question [Enhancify Financing Backend Portal]');
      sendQuestion(params)
        .then((response) => {
          if (response.status === 200) {
            this.$buefy.toast.open({
              message: 'Thank You! Your question has been successfully sent!',
              type: 'is-success',
              duration: 3000,
            });
          }
        })
        .catch(() => this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com', type: 'is-danger', duration: 3000 }))
        .finally(() => {
          this.emailSending = false;
        });
    },
    cancel(catId, catType, limit) {
      if (this.$refs.plyr.player) {
        if (this.$refs.plyr.player.currentTime !== 0) {
          this.setStatisticByVideoId('paused', this.currentVideoIndex);
        }
        this.$refs.plyr.player.destroy();
      }
      this.videoNotEnded = [];
      this.videoEnded = [];
      this.changeNewVideo(catType);
      setTimeout(() => {
        this.materialsByCategory(catId, catType, limit, false);
      }, 1000);
      this.closeModalVideo();
    },
    playItem(index) {
      this.isPreloading = true;
      if (this.isPlaying === true) {
        this.notPlay = false;
        this.setStatisticByVideoId('paused', this.currentVideoIndex);
        this.isPlaying = false;
      }
      this.currentVideoIndex = index;
      setTimeout(() => {
        materialsByCategoryId(
          this.userId, this.catId,
          this.page, this.limit,
        ).then((response) => {
          this.$set(this.videoList, 'list', response.data.data);
        });
        this.currentVideoId = this.videoList.list[index].id;
      }, 500);
      this.$refs.plyr.player.muted = true;
      setTimeout(() => {
        if (this.videoList.list[index].videoType === 'youtube') {
          this.$refs.plyr.player.source = {
            type: 'video',
            poster: this.videoList.list[index].videoImg,
            sources: [
              {
                src: this.videoList.list[index].videoSrc,
                provider: 'youtube',
              },
            ],
          };
        } else {
          this.$refs.plyr.player.source = {
            type: 'video',
            poster: this.videoList.list[index].videoImg,
            sources: [
              {
                src: this.videoList.list[index].videoSrc,
                type: this.videoList.list[index].videoType,
              },
            ],
          };
        }
      }, 800);
      if (this.notPlay === false) {
        // trayning
        if (this.videoList.list[index].currentVideoTime > 0
            && this.videoList.list[index].videoTrack !== '100%') {
          setTimeout(() => {
            const time = this.videoList.list[index].currentVideoTime - 0.01;
            this.$refs.plyr.player.currentTime = time;
            setTimeout(() => {
              this.$refs.plyr.player.play();
              this.$refs.plyr.player.muted = false;
              setTimeout(() => {
                this.isPreloading = false;
              }, 100);
            }, 500);
          }, 2800);
        } else {
          setTimeout(() => {
            this.$refs.plyr.player.play();
            this.$refs.plyr.player.muted = false;
            setTimeout(() => {
              this.isPreloading = false;
            }, 300);
          }, 600);
        }
        this.$refs.plyr.player.once('playing', () => {
          setTimeout(() => {
            this.setStatisticByVideoId('started', index);
            this.isPlaying = true;
          }, 3500);
        });
        this.$refs.plyr.player.once('pause', () => {
          if (this.$refs.plyr.player.duration !== this.$refs.plyr.player.currentTime
              && this.currentVideoIndex === index) {
            this.isPlaying = false;
            this.notPlay = false;
            this.setStatisticByVideoId('paused', index);
          }
        });
        this.$refs.plyr.player.once('ended', () => {
          if (this.currentVideoIndex === index) {
            this.isPlaying = false;
            this.notPlay = false;
            this.setStatisticByVideoId('ended', index);
          }
        });
      } else {
        // onbording trayning
        if (this.videoList.list[index].currentVideoTime > 0
            && this.videoList.list[index].videoTrack !== '100%') {
          setTimeout(() => {
            const time = this.videoList.list[index].currentVideoTime - 0.01;
            this.$refs.plyr.player.currentTime = time;
            setTimeout(() => {
              this.$refs.plyr.player.pause();
              this.$refs.plyr.player.muted = false;
              this.isPreloading = false;
            }, 600);
          }, 2800);
        } else {
          setTimeout(() => {
            this.$refs.plyr.player.play();
            this.$refs.plyr.player.pause();
            this.$refs.plyr.player.muted = false;
            this.isPreloading = false;
          }, 2800);
        }
        this.$refs.plyr.player.once('playing', () => {
          setTimeout(() => {
            this.isPlaying = true;
          }, 1500);
        });
        this.$refs.plyr.player.on('pause', () => {
          setTimeout(() => {
            if (this.$refs.plyr.player.duration !== this.$refs.plyr.player.currentTime
                && this.currentVideoIndex === index) {
              this.isPlaying = false;
              this.setStatisticByVideoId('paused', index);
            }
          }, 1500);
        });
        this.$refs.plyr.player.once('ended', () => {
          if (this.currentVideoIndex === index) {
            this.isPlaying = false;
            this.setStatisticByVideoId('ended', index);
          }
        });
      }
      if (this.videoActive === false && this.$refs.plyr.player) {
        this.$refs.plyr.player.destroy();
      }
      setTimeout(() => {
        const element = document.querySelector('.plyr');
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    },
    setStatisticByVideoId(status, index) {
      this.notPlay = false;
      if (this.isSwitched === false) {
        const params = new FormData();
        params.set('videoId', this.videoList.list[index].id);
        params.set('userId', this.userId);
        params.set('videoStatus', status);
        params.set('videoTime', this.$refs.plyr.player.currentTime);
        params.set('videoDuration', this.$refs.plyr.player.duration);
        if ((status !== 'paused' || this.$refs.plyr.player.currentTime !== 0
            || this.videoList.list[index].videoStatus !== 'ended')) {
          setStatVideo(params).then(() => {
          })
            .catch((error) => {
              this.error = error;
            })
            .finally(() => {
              if (status === 'ended') {
                const i = this.videoNotEnded.indexOf(index);
                if (i !== -1) {
                  this.videoNotEnded.splice(i, 1);
                }
                if (this.videoNotEnded.length === 0) {
                  this.videoStop();
                } else {
                  const [first] = this.videoNotEnded;
                  this.playItem(first);
                }
              }
            });
        }
      }
      if (this.isSwitched === true) {
        if (status === 'ended') {
          const i = this.videoNotEnded.indexOf(index);
          if (i !== -1) {
            this.videoNotEnded.splice(i, 1);
          }
          if (this.videoNotEnded.length === 0) {
            this.videoStop();
          } else {
            const [first] = this.videoNotEnded;
            this.playItem(first);
          }
        }
      }
    },
    videoStop() {
      this.$refs.plyr.player.stop();
    },
  },
};
</script>

<style scoped lang="stylus">
@import "~vue-plyr/dist/vue-plyr.css"
.training-ang-faqs
  height auto
  overflow hidden
  font-family Fira Sans
  font-weight 400
  font-size 18px
  line-height 28px
  padding-left 18px
  padding-right 18px
  @media screen and (max-width: 1023px)
    padding-left 4px
    padding-right 4px
  @media screen and (max-width: 769px)
    font-size 18px
    line-height 25px
  @media screen and (max-width: 600px)
    font-size 16px
    line-height 25px
    padding-left 0
    padding-right 0
  a
    color #188DFC!important
    &:hover
      text-decoration underline!important
  hr
    height 1px
    background-color #8FA7B3
    margin 50px 0
  h2
    position relative
    display inline-block
    @media screen and (max-width: 600px)
      text-align center
    span
      margin-right 30px
      @media screen and (max-width: 769px)
        margin-right 20px
      @media screen and (max-width: 600px)
        margin 13px auto 0
    span.new
      width 152px
      height 38px
      background #4C7B93
      color #fff
      padding 7px 10px
      display inline-block
      margin-left 0
      position relative
      font-size 18px
      font-weight 500
      line-height 27px
      text-align left
      @media screen and (max-width: 769px)
        width 135px
        height 33px
        font-size 16px
        padding 3px 10px
        margin-left 0
        margin-top 10px
      @media screen and (max-width: 600px)
        display block
        margin 13px auto 0
      &:after
        content ''
        display inline-block
        width 60px
        height 60px
        background-color #fff
        right -42px
        top -11px
        clip-path polygon(50% 0, 100% 50%, 50% 100%, 0 50%)
        transition 1s clip-path
        position absolute
        @media screen and (max-width: 769px)
          width 41px
          height 41px
          right:-26px
          top -4px
        @media screen and (max-width: 400px)
          display none
  .banner_bg
    max-width 342px
    min-width 175px
    width 25%
    height auto
    background linear-gradient(100deg, #1C418C 12.41%, #68BA62 106.24%, #68BA62 106.24%)
    background-blend-mode hard-light
    background-position right 0
    clip-path polygon(0 0, 100% 0, calc(100% - 40px) 100%, 0 100%)
    display flex
    justify-content center
    align-items center
    padding 40px 40px 40px 20px
    @media screen and (max-width: 769px)
      max-width 214px
      padding 20px 40px 20px 20px
    @media screen and (max-width: 600px)
      max-width 100%
      width 100%
      clip-path polygon(0 0, 100% 0, 100% calc(100% - 40px), 0 100%)
      padding 20px 20px 50px 20px
  .banner_bg img
    width 80%
    max-width 175px
    height auto
    @media screen and (max-width: 600px)
      width 84px
  .banner_content
    padding 20px 40px
    width 75%
    display flex
    flex-direction column
    justify-content center
    @media screen and (max-width: 768px)
      padding 10px 20px 20px
    @media screen and (max-width: 600px)
      width 100%
      align-items center
      p
        text-align center
    p
      font-size 20px
      line-height 28px
      @media screen and (max-width: 1023px)
        font-size 18px
        line-height 25px
      @media screen and (max-width: 600px)
        font-size 16px
        line-height 22px
    button
      max-width 12.5rem
      margin-top 25px
      background #68BA62
      height 60px
      font-size 22px
      line-height 24px
      font-weight 500
      font-family Fira Sans
      @media screen and (max-width: 769px)
        font-size 20px
        line-height 24px
        height 55px
      @media screen and (max-width: 600px)
        max-width 221px
        width 100%
        height 48px
        font-size 18px
        line-height 24px
      &:hover
        background-color #17B548
  .banner
    width 100%
    position relative
    margin 0
    padding 0
    background-clip padding-box
    border solid 3px transparent
    background-color #fff
    box-shadow 0 4px 10px rgba(0, 0, 0, 0.25)
    display flex
    flex-direction row
    margin-bottom 30px
    @media screen and (max-width: 768px)
      border solid 2px transparent
    @media screen and (max-width: 600px)
      flex-direction column
    &:before
      content ''
      position absolute
      top 0
      right 0
      bottom 0
      left 0
      z-index -1
      margin -3px
      background linear-gradient(90deg, #1C418C 0%, #68BA62 100%)
      @media screen and (max-width: 768px)
        margin -2px
  .traning_cat
    border 2px solid #8FA7B3
    padding 30px 40px
    margin-bottom 50px
    p
      color #525F66
      text-align left
    @media screen and (max-width: 1023px)
      padding 20px 30px
      margin-bottom 45px
    @media screen and (max-width: 768px)
      margin-bottom 30px
    @media screen and (max-width: 600px)
      text-align center
      padding 20px 20px
  .traning_cat_videos
    display flex
    flex-flow row wrap
    margin-top 30px
    @media screen and (max-width: 600px)
      align-items center
      flex-flow column
  .button.is-success.show-more
    max-width 420px
    width 100%
    margin 20px auto
    background #68BA62
    height 60px
    position relative
    display none
    font-size 22px
    line-height 24px
    font-weight 500
    font-family Fira Sans
    @media screen and (max-width: 769px)
      font-size 20px
      line-height 24px
      height 55px
    @media screen and (max-width: 600px)
      width 100%
      height 48px
      font-size 18px
    &:after
      content ''
      width 14px
      height 14px
      transform rotate(45deg)
      background #68BA62
      position absolute
      bottom -7px
      left 50%
    &:hover
      background-color #17B548
      &:after
        background-color #17B548
  .button.is-success.hide-more
    max-width 420px
    width 100%
    margin 20px auto
    background #68BA62
    height 60px
    font-size 22px
    line-height 24px
    font-weight 500
    display none
    position relative
    font-family Fira Sans
    @media screen and (max-width: 769px)
      font-size 20px
      line-height 24px
      height 55px
    @media screen and (max-width: 600px)
      height 48px
      font-size 18px
    &:after
      content ''
      width 14px
      height 14px
      transform rotate(45deg)
      background #68BA62
      position absolute
      top -7px
      left 50%
    &:hover
      background-color #17B548
      &:after
        background-color #17B548
  .traning_cat_video
    width 22%
    text-align left
    &:not(:nth-child(4n))
      margin-right 4%
    @media screen and (max-width: 870px)
      width 47%
      &:not(:nth-child(4n))
        margin-right 0
      &:not(:nth-child(2n))
        margin-right 6%
    @media screen and (max-width: 600px)
      width 100%
      max-width 260px
      &:not(:nth-child(4n))
        margin-right 0
      &:not(:nth-child(2n))
        margin-right 0
  .video
    width 100%
    position relative
    display flex
    background-color #000
    aspect-ratio 16/10
    box-shadow 0 4px 10px rgba(0, 0, 0, 0.25)
  img
    width 100%
    height 100%
  .video .arrow
    width 100%
    height 100%
    position absolute
    display flex
    align-items center
    justify-content center
    cursor pointer
    top 0
    left 0
    &:after
      width 60px
      height 60px
      background rgba(255, 255, 255, 0.5)
      border-radius 50%
      content '▷'
      color #ffffff
      font-size 1.6em
      display flex
      align-items center
      justify-content center
      @media screen and (max-width: 1285px)
        width 40px
        height 40px
        font-size 1.1em
      @media screen and (max-width: 768px)
        width 60px
        height 60px
        font-size 1.6em
  .video .time
    position absolute
    left 10px
    bottom 10px
    background #FFFFFF
    border-radius 2px
    display inline-block
    text-align center
    padding 7px 12px
    font-weight 600
    font-size 17px
    line-height 26px
    @media screen and (max-width: 1285px)
      padding 5px 10px
      font-size 16px
      left 5px
      bottom 5px
    @media screen and (max-width: 1023px)
      padding 2px 5px
      font-size 16px
      left 3px
      bottom 3px
    @media screen and (max-width: 768px)
      padding 7px 12px
      font-size 17px
      left 10px
      bottom 10px
  .video .check
    position absolute
    right 10px
    top 10px
    background #68BA62
    border-radius 3px
    width 41px
    height 41px
    border 1px solid #FFFFFF
    display inline-block
    text-align center
    padding 7px 8px
    font-weight 400
    font-size 27px
    line-height 26px
    &:after
      color #fff
      content '✓'
    @media screen and (max-width: 1285px)
      padding 1px 6px
      width 30px
      height 30px
      font-size 21px
      right 5px
      top 5px
    @media screen and (max-width: 1023px)
      padding 1px 5px
      font-size 20px
      right 3px
      top 3px
    @media screen and (max-width: 768px)
      padding 7px 12px
      font-size 27px
      width 41px
      height 41px
      right 10px
      top 10px
  .video .track
    position absolute
    left 0
    bottom 0
    background #68BA62
    width 0
    height 5px
    display inline-block
  .video-name
    padding 10px 0 20px
    color #293033
    font-weight 500
    font-size 18px
    line-height 25px
    display inline-block
    box-sizing border-box
    text-align left
    @media screen and (max-width: 1023px)
      line-height 22px
      font-size 16px
    @media screen and (max-width: 768px)
      line-height 22px
      font-size 16px
  .faqs_cat
    border 2px solid #8FA7B3
    padding 30px 50px
    margin-bottom 30px
    p
      color #525F66
    @media screen and (max-width: 1023px)
      padding 20px 30px
    @media screen and (max-width: 768px)
      padding 20px 20px
  .faqs_cat_faqs
    p
      font-weight 400
      font-size 18px
      line-height 25px
      padding-bottom 10px
      @media screen and (max-width: 769px)
        font-size 18px
        line-height 25px
      @media screen and (max-width: 600px)
        font-size 16px
        line-height 22px
    h3
      padding-top 20px
      position relative
      display inline-block
      cursor pointer
    .question
      display flex
      font-weight 600
      color #525F66
      padding 10px 0 10px 0
      position relative
      @media screen and (max-width: 600px)
        padding 10px 0 10px 0
      p
        font-weight 600
        text-decoration-line underline
        margin-bottom: 0;
        cursor pointer
    .answer
      display block
      color #525F66
      padding 5px 0 5px 45px
      @media screen and (max-width: 600px)
        padding-left 45px
      font-weight 400
      text-decoration-line none
      a
        color #188DFC
        text-decoration none
        &:hover
          color #188DFC
          text-decoration underline
    .category_lvl_1
      background-color #4c7b93
      color white
      width 30px
      height 30px
      margin-right 20px
      text-align center
      border-radius 3px
    .category-h3
      display flex
      align-items center
    .category_lvl_2
      background-color transparent
      color #68ba62
      //display inline-block
      margin-right 20px
      font-size 24px
      vertical-align middle
      //width 30px
      //height 30px
      text-align center
  .asq-question
    width 100%
    box-shadow 10px 0 30px rgba(156, 173, 173, 0.2)
    position relative
    margin 40px 0 0
    padding 0
    display flex
    flex-direction row
    @media screen and (max-width: 750px)
      flex-direction column
  .asq-question_bg
    width 55%
    background linear-gradient(100deg, #1C418C 12.41%, #68BA62 106.24%, #68BA62 106.24%)
    background-blend-mode hard-light
    background-position right 0
    clip-path polygon(0 0, 100% 0, calc(100% - 40px) 100%, 0 100%)
    display flex
    align-items center
    padding 24px 30px 24px 5%
    @media screen and (max-width: 1500px)
      width 60%
    @media screen and (max-width: 1023px)
      width 60%
      padding 15px 20px 15px 20px
    @media screen and (max-width: 750px)
      max-width 100%
      width 100%
      clip-path polygon(0 0, 100% 0, 100% calc(100% - 40px), 0 100%)
      padding 20px 20px 40px 20px
      flex-direction column
    div
      color #fff
      font-weight 800
      font-size 30px
      line-height 48px
      padding-left 32px
      display inline-block
      @media screen and (max-width: 1023px)
        font-size 24px
        line-height 33px
        padding-left 15px
      @media screen and (max-width: 810px)
        font-size 20px
        line-height 27px
        padding 10px 9px 0
      @media screen and (max-width: 750px)
        display block
        font-size 22px
        line-height 30px
        padding 10px 0 0
      @media screen and (max-width: 500px)
        font-size 18px
        line-height 25px
    img
      width 80%
      max-width 107px
      @media screen and (max-width: 1023px)
        max-width 90px
        width 75%
      @media screen and (max-width: 769px)
        max-width 84px
        width 66%
      @media screen and (max-width: 750px)
        width 84px
.asq-question_content
  padding 0 30px
  width 40%
  display flex
  flex-direction column
  justify-content center
  @media screen and (max-width: 1023px)
    padding 0 20px
    width 50%
  @media screen and (max-width: 750px)
    width 100%
    padding 10px 20px 20px
  button
    max-width 317px
    background #68BA62
    min-height 60px
    font-size 22px
    line-height 24px
    font-weight 500
    align-self center
    font-family Fira Sans
    padding 0 50px
    &:hover
      background-color #17B548
    @media screen and (max-width: 1400px)
      padding 0 30px
    @media screen and (max-width: 1123px)
      padding 0 20px
    @media screen and (max-width: 1023px)
      max-width 236px
      padding 0 20px
    @media screen and (max-width: 769px)
      font-size 20px
      line-height 24px
      min-height 55px
    @media screen and (max-width: 750px)
      max-width 215px
      white-space break-spaces
      font-size 18px
    @media screen and (max-width: 600px)
      min-height 48px
.faq
  padding-left 40px
  @media screen and (max-width: 769px)
    padding-left 0
.green
  color #68BA62
.button.is-success.show
  display block!important
.button.is-success.hide
  display none!important
.training-ang-faqs .answer a
  color #188DFC
  text-decoration none
.training-ang-faqs .answer a:hover
  color #188DFC!important
  text-decoration underline!important
.main
  margin-left 0
  width 100%
.plyr {
  min-width: 300px;
  min-height: 300px;
  max-height: 100%;
  height:fit-content;
  aspect-ratio 16/10
  flex-basis 74%;
  filter: drop-shadow(-3px 10px 14px rgba(14, 17, 29, 0.3));
  @media screen and (max-width: 768px) {
    flex-basis 100%;
    padding-right: 0;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  video {
    width: 100%;
    height: 100%;
  }
}
.pl_video {
  @media screen and (max-width: 768px) {
    flex-basis 48%;
  }
  @media screen and (max-width: 500px) {
    flex-basis 100%;
  }
}
.main-preview-player {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 300px;
  height:auto;
  width:100%;
  max-height: 96%;
  position:relative;
}
.playlist-container
  position: absolute;
  top:0;
  right:0;
  width:24%;
  overflow-y auto
  padding-left 1%
  padding-right 2%
  max-height 100%
  height auto
  @media screen and (max-width: 768px)
    padding-left 0
    margin-top:20px
    max-height 100%
    flex-direction row
    display flex
    flex-wrap wrap
    justify-content space-between
    position static
    width 100%
    padding-right 0
    overflow-y unset
    border 0
    @media screen and (max-width: 500px)
      border-top 1px solid #8FA7B3
  .playlist_video
    @media screen and (max-width: 768px)
      padding-top 20px
  .playlist_img
    width 100%
    min-width 150px
    position relative
    display inline-block
    cursor pointer
    line-height 0
    box-shadow 0 4px 10px rgba(0, 0, 0, 0.25)
    img
      width 100%
      aspect-ratio 16/10
    .time
      position absolute
      left 10px
      bottom 10px
      background #FFFFFF
      border-radius 2px
      display inline-block
      text-align center
      padding 7px 12px
      font-weight 600
      font-size 17px
      line-height 26px
      @media screen and (max-width: 1285px)
        padding 5px 10px
        font-size 16px
        left 5px
        bottom 5px
      @media screen and (max-width: 1023px)
        padding 2px 5px
        font-size 16px
        left 3px
        bottom 3px
      @media screen and (max-width: 768px)
        padding 7px 12px
        font-size 17px
        left 10px
        bottom 10px
    .check
      position absolute
      right 10px
      top 10px
      background #68BA62
      border-radius 3px
      width 41px
      height 41px
      border 1px solid #FFFFFF
      display inline-block
      text-align center
      padding 7px 8px
      font-weight 400
      font-size 27px
      line-height 26px
      &:after
        color #fff
        content '✓'
      @media screen and (max-width: 1285px)
        padding 1px 6px
        width 30px
        height 30px
        font-size 21px
        right 5px
        top 5px
      @media screen and (max-width: 1023px)
        padding 1px 5px
        font-size 20px
        right 3px
        top 3px
      @media screen and (max-width: 768px)
        padding 7px 12px
        font-size 27px
        width 41px
        height 41px
        right 10px
        top 10px
    .track
      position absolute
      left 0
      bottom 0
      background #68BA62
      width 0
      height 5px
      display inline-block
    .arrow
      width 100%
      height 100%
      position absolute
      display flex
      align-items center
      justify-content center
      cursor pointer
      top 0
      left 0
      &:after
        width 60px
        height 60px
        background rgba(255, 255, 255, 0.5)
        border-radius 50%
        content '▷'
        color #fff
        font-size 1.6em
        display flex
        align-items center
        justify-content center
        @media screen and (max-width: 1285px)
          width 40px
          height 40px
          font-size 1.1em
        @media screen and (max-width: 768px)
          width 60px
          height 60px
          font-size 1.6em
    .arrow.active {
      &:after {
        content: "Now playing";
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(10, 10, 10, 0.65);
        color: #fff;
        font-size: 30px;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0;
        @media screen and (max-width: 1285px) {
          font-size: 20px;
        }
        @media screen and (max-width: 1023px) {
          font-size: 18px;
        }
        @media screen and (max-width: 768px) {
          font-size: 30px;
        }
        @media screen and (max-width: 600px) {
          font-size: 22px;
        }
        @media screen and (max-width: 500px) {
          font-size: 26px;
        }
      }
    }
  .video-name
    padding 0 0 15px
    color #293033
    font-weight 500
    font-size 20px
    line-height 28px
    display inline-block
    box-sizing border-box
    text-align left
    @media screen and (max-width: 1023px)
      line-height 20px
      font-size 16px
    @media screen and (max-width: 768px)
      line-height 25px
      font-size 18px
.green
  color #68BA62
.enhfas
  font-weight 100
  margin -5px
.dialog .modal-card .modal-card-body .field
  margin-top 0
.mpc.videoPlayer
  z-index 100
  >>> .animation-content
    max-width 100% !important
    width 100%
    height 100%
    background-color #fff
    .modal-close
      display none
      &:active
        display block
    @media(max-width:1320px)
      width 100%
  .modal-card
    height: 100%;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    box-sizing: border-box;
    @media(max-width:1023px)
      overflow-y auto
    @media(max-width:768px)
      overflow-y auto
  .modal-close
    transform translateY(-50%)
    border none
    background none
    right 5px
    top 20px
    position absolute
    font-wright bold
    &:before
      background-color #808080
      height 3px
    &:after
      background-color #808080
      width: 3px;
  .is-large.modal-close
    height 40px
    max-height 40px
    max-width 40px
    min-height 40px
    min-width 40px
    width 42px
  .modal-card .modal-card-head
    background-color #fff
    padding 30px 5% 0
    border 0
    position relative
    display block
    @media(max-width:1023px)
      padding 30px 40px 0
    @media(max-width:500px)
      padding 30px 20px 0
    .modal-close
      display block
      &:active
        display block
    p
      width 100%
    @media(max-width:1023px)
      padding 30px 20px 0
    p#video-name
      padding-bottom 40px
      color #293033
      font-weight 700
      font-size 24px
      line-height 34px
      display inline-block
      box-sizing border-box
      text-align left
      @media screen and (max-width: 1023px)
        padding-bottom 30px
      @media screen and (max-width: 768px)
        line-height 30x
        font-size 22px
        padding-bottom 25px
      @media screen and (max-width: 500px)
        line-height 28px
        font-size 20px
        padding-bottom 20px
  .modal-card-title
    font-family Fira Sans
    font-weight 700
    font-size 30px
    line-height 42px
    color #4C7B93
    padding-bottom 10px
    @media screen and (max-width: 768px)
      line-height 40px
      font-size 28px
    @media screen and (max-width: 500px)
      line-height 33px
      font-size 24px
  .modal-card .modal-card-body
    background-color #fff
    padding 0 5% 0
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    flex-grow: 0;
    max-height: 100%;
    @media(max-width:1023px)
      padding 0 40px 0
      overflow unset
    @media(max-width:768px)
      overflow unset
    @media(max-width:500px)
      padding 0 20px 0
.modal.videoPlayer{
  justify-content: start;
}
.ytp-chrome-top, .ytp-chrome-bottom{
  display:none!important;
}
.ytp-watermark yt-uix-sessionlink{
  display:none!important;
}
.ytp-gradient-top{
  display:none!important;
}
.ytp-title{
  display:none!important;
}
.ytp-chrome-top-buttons{
  display:none!important;
}
.ytp-pause-overlay-container{
  display: none!important;
}
.ytp-expand-pause-overlay .ytp-pause-overlay{
  display: none!important;
}
.icon
  .angle-up
    transform scale(0.8)
  .angle-down
    transform scale(0.8)
</style>
